module.exports = __webpack_public_path__ + "img/pd-img32.6cfdd971.png";